import React from 'react';
import { Heading } from '../../../common/TextComponents';
import { useAuthContext } from '../../../../hooks/useAuthContext';
import PageLayout from '../../../layout/PageLayout';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const DashboardLayout = ({ 
  children, 
  tabs, 
  activeTab, 
  setActiveTab, 
  loading,
  error
}) => {
  const { user } = useAuthContext();

  return (
    <PageLayout showProfileMenu={true}>
      <div className="mx-auto max-w-4xl">
        {/* Tabs - only show if tabs are provided */}
        {tabs && tabs.length > 0 && (
          <div className="mb-8">
            {/* Mobile tabs (dropdown) */}
            <div className="grid grid-cols-1 sm:hidden">
              <select
                value={activeTab}
                onChange={(e) => setActiveTab(e.target.value)}
                className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-600 dark:bg-gray-700 dark:text-gray-100 dark:outline-gray-600 dark:focus:outline-purple-500"
              >
                {tabs.map((tab) => (
                  <option key={tab.key} value={tab.key}>
                    {tab.name} {tab.locked && "🔒"}
                  </option>
                ))}
              </select>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500 dark:fill-gray-400" 
                viewBox="0 0 20 20" 
                fill="currentColor"
              >
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
            
            {/* Desktop tabs */}
            <div className="hidden sm:block">
              <div className="border-b border-gray-200 dark:border-gray-700">
                <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                  {tabs.map((tab) => (
                    <button
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      className={classNames(
                        tab.current
                          ? 'border-purple-500 text-purple-600 font-bold dark:text-purple-400'
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-300 dark:hover:border-gray-500 dark:hover:text-gray-200',
                        'group inline-flex items-center border-b-2 px-1 py-4 text-base md:text-lg'
                      )}
                    >
                      <span>{tab.name}</span>
                      {tab.locked && (
                        <svg 
                          xmlns="http://www.w3.org/2000/svg" 
                          viewBox="0 0 24 24" 
                          fill="currentColor" 
                          className="w-5 h-5 ml-1.5 text-gray-400 dark:text-gray-500"
                        >
                          <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clipRule="evenodd" />
                        </svg>
                      )}
                    </button>
                  ))}
                </nav>
              </div>
            </div>
          </div>
        )}
        
        {loading ? (
          <div className="py-12 flex justify-center">
            <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-purple-500 border-r-transparent dark:border-purple-400"></div>
          </div>
        ) : error ? (
          <div className="mt-12 p-6 bg-red-50 rounded-xl dark:bg-red-900/30">
            <p className="text-red-700 dark:text-red-400">{error}</p>
            <button 
              className="mt-4 inline-flex items-center justify-center rounded-md bg-purple-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600 dark:bg-purple-700 dark:hover:bg-purple-600"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        ) : (
          <div className="mt-4">
            {children}
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default DashboardLayout;
